import {
  CHANGE_LANGUAGE_TEMP,
  UPDATE_USER_SETTINGS,
  DESTROY_USER_SETTINGS,
  RETRIEVE_LOAD_USER_INFO,
} from "../actions/types";

const DEFAULT_STATE = {
  avatarBorderColor: "#000000",
  avatarBackground: "#FFFFFF",
  avatarId: "lion1",
  userName: "",
  language: "en-US",
  background: "background1"
}

const userSettingsReducer = (state = DEFAULT_STATE, action) => {
  switch(action.type) {
    case UPDATE_USER_SETTINGS: 
      return { 
        ...state,
        // do nothing for now
      };

    case DESTROY_USER_SETTINGS:
      return { ...DEFAULT_STATE };

    case CHANGE_LANGUAGE_TEMP:
      return {
        ...state,
        language: action.payload,
      };

    case RETRIEVE_LOAD_USER_INFO:
    // case XYZ: other actions return data from DB are most likely go through the same logic
      // data is retrieved from database already, now extract data out and setup into the store
      // only load user settings if the status ode is 200.
      if (action.payload.status === 200) {
        const data = action.payload.data;
        // user settings
        const avatarBorderColor = data.avatarBorderColor;
        const avatarBackground = data.avatarBackground;
        const avatarId = data.avatarId;
        const userName = data.userName;
        const language = data.language;
        const background = data.background;

        return {
          avatarBorderColor,
          avatarBackground,
          avatarId,
          userName,
          language,
          background
        };
      };
      // if the status code is not 200, do not update this redux store
      return state;  

    default: 
      return state;
  }
}

export default userSettingsReducer;